import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import MovieCard from "@/components/feature/MovieCard";

type LatestUpdatesProps = {
  movies: Movie[];
};

export default function LatestUpdates({ movies }: LatestUpdatesProps) {
  return (
    <section className="flex-1">
      <div className="mb-5 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-700">
            <i className="ri-time-line" />
          </span>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            最新更新
          </h2>
        </div>
        <Link
          to="/category"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          查看全部
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-3">
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}